import { Alert, Container } from '@mui/material';
import { useLocation, useSearchParams } from 'react-router-dom';
import LPCouponDetails from '../coupon-lp-details/coupon-lp-details';
import LPProductDetails from '../product-lp-details/product-lp-details';

export default function LPBenefitDetails() {
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();
  const type = searchParams.get('benefitType');
  if ((pathname.includes('/edit/') && !type) || (type && type !== 'coupon' && type !== 'product')) {
    return (
      <Container>
        <Alert severity="error">
          Tipo de benefício inválido. Acesse o benefício pela listagem.
        </Alert>
      </Container>
    );
  }
  return type === 'product' ? (
    <LPProductDetails key={pathname} />
  ) : (
    <LPCouponDetails key={pathname} />
  );
}
